
import { useParams } from "react-router-dom";
import PageLayout from "@/components/PageLayout";
import CompanyForm from "@/components/CompanyForm";
import { useCompanyOperations } from "@/hooks/useCompanyOperations";
import { LoadingState, NotFoundState, EditCompanyForm } from "@/components/company/CompanyEditStates";

const EditCompany = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const { company, loading, updateCompany, navigateToDashboard } = useCompanyOperations(companyId);

  if (loading) {
    return (
      <PageLayout title="Loading...">
        <LoadingState />
      </PageLayout>
    );
  }

  if (!company) {
    return (
      <PageLayout title="Company Not Found">
        <NotFoundState />
      </PageLayout>
    );
  }

  return (
    <PageLayout title={`Edit ${company.name}`}>
      <EditCompanyForm 
        company={company} 
        onSubmit={updateCompany}
        onCancel={navigateToDashboard}
      />
    </PageLayout>
  );
};

export default EditCompany;
